import styled from 'styled-components';

export const Decoline = styled.img`
  position: absolute;
  width: 380;
  height: 17;
  top: 144;
  left: 322;
`;

export const ClickableContainer = styled.div`
  position: absolute;
  top: 100;
  transform-origin: center center;
  cursor: pointer;
`;

export const ModalContainer = styled.div`
  position: absolute;
  width: 800;
  height: 104;
  top: 97;
  left: 112;
  opacity: 0.8;
  background-image: ${({ isFinished }) => (isFinished ?
    'linear-gradient(to left, rgba(2, 18, 15, 0), #02120f 37%, #02120f 65%, rgba(2, 18, 15, 0))' :
    'linear-gradient(to left, rgba(17, 10, 2, 0), #110a02 37%, #110a02 65%, rgba(17, 10, 2, 0))')};
`;

export const ModalHeader = styled.h3`
  margin: 0;
  position: absolute;
  width: 455;
  height: 34;
  top: 109;
  left: 285;
  font-family: Quicksand Medium;
  font-size: 27;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
`;

export const ModalDescription = styled.p`
  margin: 0;
  position: absolute;
  width: 550;
  height: 23;
  top: 167;
  left: 237;
  opacity: 0.8;
  font-family: Open Sans;
  font-size: 17;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
`;

export const Progress = styled.div`
  position: absolute;
  top: 573;
  left: 0;
  width: 1024;
  height: 3;
  overflow: hidden;
  z-index: 100;
`;

export const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 1024;
  height: 576;
  overflow: hidden;
  z-index: 100;
`;

export const Background = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 1024;
  height: 576;
  z-index: 100;
`;

export const Block = styled.div`
  position: absolute;
  top: 600;
  left: 0;
  width: 1024;
  height: 172;
  opacity: 0.8;
  background-color: #110a02;
  z-index: 100;
`;

export const TopLine = styled.div`
  position: absolute;
  top: 12;
  left: 0;
  width: 1024;
  height: 2;
  opacity: 0.5;
  background-color: #a17560;
  z-index: 100;
`;

export const BottomLine = styled(TopLine)`
  top: 152;
`;

export const VerticalLine = styled(TopLine)`
  top: 57;
  left: 785;
  width: 2;
  height: 50;
`;

export const RedirectIcon = styled.img`
  position: absolute;
  top: 0;
  left: 77;
  width: 165;
  height: 165;
  z-index: 100;
`;

export const TextContainer = styled.div`
  position: absolute;
  top: 46;
  left: 312;
  width: 450;
  height: 68;
  z-index: 100;
`;

export const LeftText = styled.div`
  font-family: Quicksand Medium;
  font-size: 27;
  color: #ffffff;
  text-align: left;
`;

export const GoTextContainer = styled.div`
  position: absolute;
  top: 58;
  left: 859;
  width: 45;
  height: 43;
  z-index: 100;
`;

export const Button = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`;

export const CenterText = styled.div`
  font-family: Quicksand Bold;
  font-size: 34;
  color: #e39976;
  text-align: center;
`;

export const ArrowRight = styled.img`
  position: absolute;
  top: 20;
  left: 897;
  width: 120;
  height: 120;
  z-index: 100;
`;
